import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M11.353 6.1V18H9.908v-5.559H4.213V18H2.768V6.1h1.445v5.134h5.695V6.1h1.445ZM19.668 18v-2.567h-5.695v-1.02L18.359 6.1h1.445l-4.301 8.16h4.182l.272-3.451 1.139-.017v3.468h1.666v1.173h-1.666V18h-1.428Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextH4Icon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'textH4'),
) as IconWithRender;

TextH4Icon.displayName = 'TextH4Icon';
TextH4Icon.propTypes = Icon.propTypes;
TextH4Icon.renderIcon = (props) => <TextH4Icon {...props} />;
export default TextH4Icon;
